const feedbackList = () => import('@/pages/user/feedback/index.vue');
const feedbackDetail = () => import('@/pages/user/feedback/detail.vue');

export default [{
    path: '/user/feedback',
    component: feedbackList,
    meta: [{
        name: '用户管理'
    },
    {
        name: '用户反馈记录',
        activeRoute: '/user/feedback'
    }]
}, {
    path: '/user/feedbackDetail',
    component: feedbackDetail,
    meta: [{
        name: '用户管理'
    },
    {
        name: '用户反馈记录',
        url: '/user/feedback'
    },
    {
        name: '用户反馈记录详情',
        activeRoute: '/user/feedback'
    }]
}];